export enum ShareLinkIncentive {
  REDDIT = 'reddit',
  INSTAGRAM = 'instagram',
  FACEBOOK = 'facebook',
  DISCORD = 'discord',
  COPY_LINK = 'copy-link',
  OTHER_CHANNELS = 'other-channels',
}
